import React from 'react';
import { ModalContent } from 'fronton-react';
import { ModalHeader, Typography } from 'common/components';
import {
  cabinetBenefitsModalContent,
  cabinetBenefitsModalText,
  cabinetBenefitsModalTitle,
} from '../../cabinet-benefits-styles';

export const Guarantee = () => (
  <>
    <ModalHeader className={cabinetBenefitsModalTitle} title="Гарантия качества 2&nbsp;года" />
    <ModalContent className={cabinetBenefitsModalContent}>
      <Typography className={cabinetBenefitsModalText} variant="m" size="body_long">
        Гарантия 2&nbsp;года&nbsp;&mdash; это ваше спокойствие и&nbsp;уверенность в&nbsp;качестве нашей продукции. Мы&nbsp;понимаем, как важны надежность и&nbsp;долговечность в&nbsp;создании мебели, поэтому предлагаем вам гарантию на&nbsp;все шкафы, выполненные на&nbsp;заказ. Это означает, что в&nbsp;течение двух лет с&nbsp;момента покупки вы&nbsp;можете быть уверены: если возникнут какие-либо проблемы с&nbsp;конструкцией или использованием шкафа, мы&nbsp;оперативно и&nbsp;без лишних вопросов решим их&nbsp;в&nbsp;соответствии с&nbsp;условиями гарантии.
      </Typography>
    </ModalContent>
  </>
);
